import { render, staticRenderFns } from "./PlayerName.vue?vue&type=template&id=8fe4abc4&scoped=true&"
import script from "./PlayerName.vue?vue&type=script&lang=js&"
export * from "./PlayerName.vue?vue&type=script&lang=js&"
import style0 from "./PlayerName.vue?vue&type=style&index=0&id=8fe4abc4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fe4abc4",
  null
  
)

export default component.exports